export default Object.freeze({
  SYSTEMATIC: 'SYSTEMATIC',
  SCOPING: 'SCOPING',
  RAPID: 'RAPID',
  UMBRELLA: 'UMBRELLA',
  NARRATIVE: 'NARRATIVE',
  META_ANALYSIS: 'META_ANALYSIS',
});
